/* ============================================================
   GlowPop lollipop stage.

   The photo is shown exactly as uploaded — nothing is drawn on
   it, re-lit or re-coloured. This script only measures where the
   ball is in the photo so the ball can be centred in its box
   (the stick hangs below), and sets the pivot so the gentle turn
   (a CSS animation of the whole image) swings round the ball's
   own vertical axis. If the photo cannot be read, it is simply
   shown whole.

   Markup (see snippets/turntable.liquid):
   <div data-turn>
     <img class="turn__src" src="...lollipop photo...">
   </div>
   ============================================================ */
(function () {
  "use strict";
  if (typeof window === "undefined") return;

  /* ---- 1. find the lollipop in the photo ------------------------------ */
  function measure(img) {
    var max = 900;
    var sc = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * sc)), hgt = Math.max(1, Math.round(img.naturalHeight * sc));
    var cv = document.createElement("canvas"); cv.width = w; cv.height = hgt;
    var cx2 = cv.getContext("2d", { willReadFrequently: true });
    cx2.drawImage(img, 0, 0, w, hgt);
    var d;
    try { d = cx2.getImageData(0, 0, w, hgt).data; } catch (err) { return null; }   // tainted: no CORS

    // the background is whatever the corners are (white, cream, ...) or transparent
    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    var corners = [px(2, 2), px(w - 3, 2), px(2, hgt - 3), px(w - 3, hgt - 3)];
    var bg = [0, 0, 0], opaque = 0;
    for (var k = 0; k < 4; k++) { if (corners[k][3] > 40) { opaque++; bg[0] += corners[k][0]; bg[1] += corners[k][1]; bg[2] += corners[k][2]; } }
    if (opaque) { bg[0] /= opaque; bg[1] /= opaque; bg[2] /= opaque; }

    var widths = new Int32Array(hgt), left = new Int32Array(hgt), right = new Int32Array(hgt);
    var y, x, i, a, dr, dg, db, ink;
    for (y = 0; y < hgt; y++) {
      var l = -1, rr = -1, cnt = 0;
      for (x = 0; x < w; x++) {
        i = (y * w + x) * 4; a = d[i + 3];
        if (a <= 40) { ink = false; }
        else if (!opaque) { ink = true; }
        else { dr = d[i] - bg[0]; dg = d[i + 1] - bg[1]; db = d[i + 2] - bg[2]; ink = (dr * dr + dg * dg + db * db) > 30 * 30; }
        if (ink) { if (l < 0) l = x; rr = x; cnt++; }
      }
      widths[y] = cnt; left[y] = l; right[y] = rr;
    }
    var top = -1;
    for (y = 0; y < hgt; y++) if (widths[y] > 0) { top = y; break; }
    if (top < 0) return null;

    // the widest row is the band's equator
    var peak = 0, eq = top;
    for (y = top; y < hgt; y++) if (widths[y] > peak) { peak = widths[y]; eq = y; }
    if (peak < 24) return null;

    // the band: the run of rows at (almost) full width around the equator
    var b0 = eq, b1 = eq;
    while (b0 > top && widths[b0 - 1] >= peak * 0.985) b0--;
    while (b1 < hgt - 1 && widths[b1 + 1] >= peak * 0.985) b1++;

    // fit a circle to the top dome's outline — the stick and any shadow can't disturb it
    var sx = 0, sy = 0, sxx = 0, syy = 0, sxy = 0, sxz = 0, syz = 0, sz = 0, n = 0;
    for (y = top + 1; y < b0 - 1; y++) {
      if (widths[y] < 2) continue;
      var pts = [[left[y], y], [right[y], y]];
      for (var j = 0; j < 2; j++) {
        var X = pts[j][0], Y = pts[j][1], Z = X * X + Y * Y;
        sx += X; sy += Y; sxx += X * X; syy += Y * Y; sxy += X * Y; sxz += X * Z; syz += Y * Z; sz += Z; n++;
      }
    }
    var cx, cy, R, ok = false;
    if (n >= 16) {
      // least squares for x^2 + y^2 + D x + E y + F = 0
      var A = [[sxx, sxy, sx], [sxy, syy, sy], [sx, sy, n]], B = [-sxz, -syz, -sz];
      var det = A[0][0] * (A[1][1] * A[2][2] - A[1][2] * A[2][1]) - A[0][1] * (A[1][0] * A[2][2] - A[1][2] * A[2][0]) + A[0][2] * (A[1][0] * A[2][1] - A[1][1] * A[2][0]);
      if (Math.abs(det) > 1e-6) {
        var inv = function (r, c) { // cofactor / det
          var m = [];
          for (var ii = 0; ii < 3; ii++) if (ii !== r) { var row = []; for (var jj = 0; jj < 3; jj++) if (jj !== c) row.push(A[ii][jj]); m.push(row); }
          return ((r + c) % 2 ? -1 : 1) * (m[0][0] * m[1][1] - m[0][1] * m[1][0]) / det;
        };
        var D = inv(0, 0) * B[0] + inv(1, 0) * B[1] + inv(2, 0) * B[2];
        var E = inv(0, 1) * B[0] + inv(1, 1) * B[1] + inv(2, 1) * B[2];
        var F = inv(0, 2) * B[0] + inv(1, 2) * B[1] + inv(2, 2) * B[2];
        cx = -D / 2; cy = -E / 2; R = Math.sqrt(Math.max(cx * cx + cy * cy - F, 0));
        ok = R > peak * 0.35 && R < peak * 0.75 && cy > top && cy < top + 2 * R + 4 && Math.abs(cx - (left[eq] + right[eq]) / 2) < peak * 0.15;
      }
    }
    if (!ok) { R = peak / 2; cy = top + R; cx = (left[eq] + right[eq]) / 2; }

    // the ball's bottom: the last row still much wider than a stick. real candy is a touch
    // fuller below the band than a perfect sphere, so grow the sphere to cover it
    var bot = eq;
    for (y = hgt - 1; y > eq; y--) if (widths[y] >= peak * 0.3) { bot = y; break; }
    if (bot > top + 1.7 * R && bot < top + 2.4 * R) {
      var Rv = (bot - top) / 2;
      if (Rv > R) { R = Rv; cy = (top + bot) / 2; }
    }

    var hh = Math.min(0.45, Math.max(0, ((b1 - b0) / 2) / R));
    var rbv = Math.min(1.10, Math.max(0.98, (peak / 2) / R));
    if (hh < 0.06) { hh = 0; rbv = 1; }                    // a plain sphere has no band worth drawing

    // how wide the stick is, a little below the ball (0 when the photo has no stick)
    var sw = 0, sc = 0;
    for (y = Math.round(bot + R * 0.15); y < Math.min(hgt, Math.round(bot + R * 0.6)); y++) if (widths[y] > 0 && widths[y] < peak * 0.3) { sw += widths[y]; sc++; }
    sw = sc ? sw / sc : 0;

    return { cx: cx / w, cy: cy / hgt, R: R / hgt, aspect: w / hgt, h: hh, rb: rbv,
             ballW: (2 * R * rbv) / w, ballH: (2 * R) / hgt, stick: sw / w,
             bg: bg, opaque: opaque > 0 };
  }

  /* ---- 2. lay the photo out so its ball fills the box ------------------ */
  function layout(root, img, m) {
    // the root box is the ball (a square). the photo is scaled so its ball matches, and
    // shifted so the ball's centre sits in the middle of the box; the stick hangs below.
    var imgH = 1 / m.ballH;                      // photo height, in box heights
    var imgW = imgH * m.aspect;                  // photo width, in box heights (box is square)
    img.style.height = (imgH * 100) + "%";
    img.style.width = "auto";
    img.style.maxWidth = "none";
    img.style.left = (50 - m.cx * imgW * 100) + "%";
    img.style.top = (50 - m.cy * imgH * 100) + "%";
    img.style.transformOrigin = (m.cx * 100).toFixed(2) + "% " + (m.cy * 100).toFixed(2) + "%";   // turn about the ball's own axis
    root.style.setProperty("--stick-below", ((imgH - m.cy * imgH - 0.5) * 100).toFixed(1) + "%");
    root.classList.add("is-placed");
  }

  // a photo we cannot read (no CORS, or not loaded): show it whole, as it is
  function fallback(root, img) {
    if (img) { img.style.height = ""; img.style.width = ""; img.style.maxWidth = ""; img.style.left = ""; img.style.top = ""; img.style.transformOrigin = ""; }
    root.classList.remove("is-placed");
    root.classList.add("is-fallback");
  }

  function setup(root) {
    var img = root.querySelector(".turn__src");
    if (!img) return;
    function go() {
      var m = measure(img);
      if (!m) { fallback(root, img); return; }
      root.setAttribute("data-turn-measure", JSON.stringify(m));
      layout(root, img, m);
    }
    if (img.complete && img.naturalWidth) go();
    else { img.addEventListener("load", go, { once: true }); img.addEventListener("error", function () { fallback(root, img); }, { once: true }); }
  }

  function init() {
    var roots = document.querySelectorAll("[data-turn]");
    for (var i = 0; i < roots.length; i++) if (!roots[i].hasAttribute("data-turn-ready")) { roots[i].setAttribute("data-turn-ready", "1"); setup(roots[i]); }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
